export const recentPurchases = [
  { name: 'Ashley M.', city: 'Austin', region: 'Texas', time: '2 minutes ago' },
  { name: 'Tyler B.', city: 'Denver', region: 'Colorado', time: '4 minutes ago' },
  { name: 'Megan W.', city: 'San Diego', region: 'California', time: '7 minutes ago' },
  { name: 'Jordan P.', city: 'Chicago', region: 'Illinois', time: '10 minutes ago' },
  { name: 'Brittany H.', city: 'Miami', region: 'Florida', time: '13 minutes ago' },
  { name: 'Kevin S.', city: 'Seattle', region: 'Washington', time: '16 minutes ago' },
  { name: 'Lauren D.', city: 'Phoenix', region: 'Arizona', time: '20 minutes ago' },
  { name: 'Ryan C.', city: 'Nashville', region: 'Tennessee', time: '24 minutes ago' },
  { name: 'Amanda G.', city: 'Boston', region: 'Massachusetts', time: '29 minutes ago' },
]
